import { FormattedMessage, useIntl } from 'react-intl';
import { PeriodDateRange } from '@/components/PeriodDateRange';
import { WarningDialog } from '../WarningDialog';
import type { CollectionTicketClaimDTO } from '@/api/trafikportalen';

interface DeletePeriodDialogProps {
  claim: CollectionTicketClaimDTO | null;
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
}

export const DeletePeriodDialog = ({
  claim,
  onClose,
  onConfirm,
  loading,
}: DeletePeriodDialogProps) => {
  const { formatMessage } = useIntl();

  return (
    <WarningDialog
      open={!!claim}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
      title={formatMessage({ defaultMessage: 'Radera period' })}
      content={
        claim && (
          <p>
            <FormattedMessage
              defaultMessage="Är du säker på att du vill radera perioden {range}?"
              values={{
                range: (
                  <PeriodDateRange
                    from={claim.valid_from}
                    to={claim.valid_to}
                  />
                ),
              }}
            />
          </p>
        )
      }
      onCancel={onClose}
      onConfirm={onConfirm}
      buttonText={formatMessage({ defaultMessage: 'Radera' })}
      loading={loading}
    />
  );
};
